<template>
    <div>

        <div>
            <div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">宿舍退房管理</div>
            <el-row style="margin-top: 9px;">
                <div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px;">

                    <el-row style="padding-left: 46px; padding-top: 40px;">

                        <el-col :span="4">
                            <span>所在宿舍</span>
                            <el-input v-model="input" placeholder="请输入宿舍名称" style="width: 60%; margin-left: 10px;">
                            </el-input>
                        </el-col>

                        <el-col :span="4">
                            <span>所在房间</span>
                            <el-input v-model="input" placeholder="请输入房间" style="width: 60%; margin-left: 10px;">
                            </el-input>
                        </el-col>

                        <el-col :span="3">
                            <span>姓名</span>
                            <el-input v-model="input" placeholder="请输入姓名" style="width: 70%; margin-left: 10px;">
                            </el-input>
                        </el-col>

                        <el-col :span="6">
                            <span>入住日期</span>
                            <el-date-picker v-model="condition.aaa" type="date" placeholder="请选择"
                                style="width: 35%; margin-left: 10px;">
                            </el-date-picker>
                            -
                            <el-date-picker v-model="value1" type="date" placeholder="请选择" style="width: 35%;">
                            </el-date-picker>
                        </el-col>

                        <el-col :span="3">
                            <el-input v-model="input" placeholder="请输查询内容">
                            </el-input>
                        </el-col>

                        <el-col :span="4">
                            <div style=" margin-left: 30px;">
                                <el-button
                                    style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
                                    查询</el-button>
                            </div>
                        </el-col>

                    </el-row>

                    <el-row style="margin: 0px 2%; margin-top: 10px;">
                        <el-row>
                            <el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
                                :row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" height="595"
                                tooltip-effect="dark" style="width: 100%;" @selection-change="handleSelectionChange">
                                <el-table-column type="selection" width="55">
                                </el-table-column>
                                <el-table-column align="center" label="序号">
                                    <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
                                </el-table-column>
                                <el-table-column prop="fgs" align="center" label="姓名"></el-table-column>
                                <el-table-column prop="csgs" align="center" label="身份证号"></el-table-column>
                                <el-table-column prop="bankuai" align="center" label="年龄"></el-table-column>
                                <el-table-column prop="xiangmu" align="center" label="性别"></el-table-column>
                                <el-table-column prop="gangwei" align="center" label="手机号"></el-table-column>
                                <el-table-column prop="gangwei" align="center" label="所在宿舍"></el-table-column>
                                <el-table-column prop="gangwei" align="center" label="所在楼层"></el-table-column>
                                <el-table-column prop="gangwei" align="center" label="所在房间"></el-table-column>
                                <el-table-column prop="gangwei" align="center" label="床号"></el-table-column>
                                <el-table-column prop="gangwei" align="center" label="入住时间"></el-table-column>
                                <el-table-column prop="gangwei" align="center" label="部门"></el-table-column>
                                <el-table-column prop="gangwei" align="center" label="项目"></el-table-column>
                                <el-table-column align="center" label="操作">
                                    <template slot-scope="scope">
                                        <img src="../../../assets/详情.png" @click="Edit(scope.row)" v-show="scope.row.state === '0'" />
                                        <span v-show="scope.row.state === '1'" style="color: #006E4B; font-size: 15px; font-weight: 600; display: inline-block; height: 38px; line-height: 38px;">已退住</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-row>
                        <el-row style="margin-top: 10px; text-align: center;">
                            <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
                                layout=" prev, pager, next, jumper" :total="total">
                            </el-pagination>
                        </el-row>
                    </el-row>
                </div>
            </el-row>
        </div>

        <div>
            <el-dialog title="退住管理" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false"
                :center="true">
                <edit ref="edit"></edit>
            </el-dialog>
        </div>

    </div>
</template>

<script>
    import edit from './SstzGl_edit.vue';

    import axios from "axios";
    export default {
        components: {
            edit: edit,
        },
        data() {
            return {
                //列表相关
                page_num: 1,
                page_size: 10,
                total: 0,
                tableData: [{
                        fgs: "123",
                        csgs: "123",
                        bankuai: "123",
                        xiangmu: "123",
                        gangwei: "123",
                        state: "0",
                    },
                    {
                        fgs: "123",
                        csgs: "123",
                        bankuai: "123",
                        xiangmu: "123",
                        gangwei: "123",
                        state: "1",
                    }
                ],

                //页面相关
                dialogVisible: false,
                //查询条件
                condition: {
                    aaa: ""
                }
            };
        },
        methods: {
            Return() {
                this.dialogVisible = false;
            },
            Edit(e) {
                this.dialogVisible = true;
            },

        },
        created() {

        }
    }
</script>

<style scoped="scoped">
    >>>.el-button:hover {
        background-color: #FFFFFF;
    }

    >>>.el-button:focus {
        background-color: #FFFFFF;
    }

    >>>.el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #006E4B;
    }

    >>>.el-input__inner:focus {
        border-color: #006E4B;
    }

    >>>.el-select .el-input.is-focus .el-input__inner {
        border-color: #006E4B;
    }

    >>>.el-checkbox__input.is-checked .el-checkbox__inner,
    >>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #006E4B;
        border-color: #006E4B;
    }

    >>>.el-checkbox__inner:hover {
        border-color: #006E4B;
    }
</style>



// WEBPACK FOOTER //
// SstzGl.vue?21537166